import { visualViewportBottomInset } from "./virtual-keyboard"
import { createVisualViewportGeometry } from "./visual-viewport"

export function createVisualViewportInset(active: () => boolean) {
  const geometry = createVisualViewportGeometry(active)
  return () => {
    const view = geometry()?.view
    return view ? visualViewportBottomInset(view) : 0
  }
}
